module.exports = __webpack_public_path__ + "src/assets/img/01_3art_3part_gallery.f54d21c6.jpg";